export const TABLETCOURSE = 'TABLETCOURSE';
